module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "chapter-2"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title case-upper"
  }, [_c('span', {
    staticClass: "element-number-term"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "element-number-number"
  }, [_vm._v("TWO")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-2-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("Jordan Spears perched")]), _vm._v(" on the edge of her bed and tried to tamp down on his anger. “Why didn’t you tell me you were dying?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Would it have made any difference?” Carla whispered. “You always were an absolute gentleman. The perfect companion. You’ve been the best thing that’s happened to me. My family believes you were only with me for my money. And I’m going to let them hold on to that lie. They’re going to be pissed that I left every dime of it to the grands. Every. Single. Dime.” She looked up at him, putting a tighter grip on his hands. “But I’ve made you the executor of the estate. You’ll see it through. I know you will.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Remembering the dour faces of her children who were holding camp in the waiting room, he was certain there would be a fight on his hands. “Are you trying to get me killed?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Not at all. Just wanted someone objective enough to make sure they knew exactly how to guide my grands into being better human beings. I failed them. Their father failed them, so I need to focus on three things—education. Living skills. No codependency. That’s what I want for them. Your center will be a big part of it.” Her gaze locked on him. “Will you do that for me, please?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“How did you know about—”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Your life is not as private as you think, Jordan Everett Spears. Your center is an amazing place. I love what you’re doing for those children and don’t understand why you have that um … other career.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“It’s not for the money.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I get that,” she countered with a smile, then gave him a wink. “So, how about one more tumble for old times’ sake?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jordan’s eyebrows winged upward. “Woman, you are not going to have me land in prison because you checked out of here in the middle of an orgasm.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She outright laughed. “I need you to promise me one other thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“What’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I need you to live a little more,” she said, and her tone held more concern than it should.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I like my life just fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Your life is boring and predictable, Jordan. You’re so afraid of living you don’t do anything outside of your comfort zone. Your meals. Your job. Your women. The same ones for ten years. You like your life orderly, styled a certain way. You have OCD.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I do not have—”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Sweetheart, I know what it looks like. I tested you out on that score.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("His head snapped up as he glared at her.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I would purposely shift things a little, just to see what you’d do,” she said, seeming to ignore the fact that he was angered that she would do such a thing. “You’d put the vase, the photos, everything back in their original place each and every time.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jordan drew his hand back, weighing her words and observations. “I compartmentalize things in my mind. It started in my youth when I was in a coma. Then, everything in my world was controlled by everyone else. So yes, I’m organized and kind of like my life that way.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Coma?” She shifted a little in the bed. “What happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I don’t think we should talk about it right now. Let’s focus on happier things, all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Well, if you want to make me happy, break me up out of this joint and take me to see the sunset at Lake Michigan.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jordan rushed towards the door.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Jordan,” she yelled. “Wait. I was only—”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He sprinted down the hall, made it to the nurse’s station and addressed the tall brunette behind the counter, “Please, get the doctor here as soon as you can.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Several nurses jumped up from their places when he said that.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“No,” he said. “Nothing’s wrong. I just need his approval to take her to the beach. She’d like to see the sunset one last time.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Two of the nurses gave each other pointed looks while the brunette said, “Call him,” to her co-workers before turning back to face Jordan. “I want to warn you that he’s not going to allow you to do that. The things we’d have to put in place to make that happen cannot be coordinated in such a short amount of time. I mean, in the time she has left...”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jordan thought that over, feeling a sense of helplessness, but with it, a plan formed until one thought hit him square on. “Then we bring the beach to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Several nurses gathered around, and the head nurse in charge said, “What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jordan fumbled in his wallet and said, “One of you, please head to Walmart and buy the largest smart television they have.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“My shift’s about to end,” the blonde said, snatching up his credit card. “I’ll do it, but I still don’t see how that’s going to work.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Just bring it. I’ll work something else on my end,” he countered while dialing his brother who didn’t answer.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He ended up calling back three more times before Zach finally picked up. “I need you to do me a huge favor, man.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Bro, I’m in the middle of the biggest client meeting ever. I only picked up because you never call back-to-back like this. So it must be an emergency.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“It is,” he said. “To me.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He quickly filled Zach in then said, “I need you to take your iPad to The Point, just past 69"), _c('sup', [_vm._v("th")]), _vm._v(" Street that overlooks the lake and the city’s skyline. You’re the closest to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I’m on it, brother.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("A sense of relief filled Jordan as he heard Zach tell the people on his end, “I’ll have to reschedule this presentation for another time …”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“So what can we do?” Another nurse said, tapping him on the shoulder. He turned, taking in the solemn expression.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Can you get an engineer up here so we can mount the television along one wall? And a tech guy in here so that my brother can stream the image in from where he is to here?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Got it.” She rushed off down the hall.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Your brother’s only going to be able to stream for so long, then his battery will die.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Damn.” Jordan hadn’t thought of that.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“You could have him live stream for as long as he can,” one of the nurses said. “Then either upload the video to play in a loop or make a television screensaver.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Great idea,” the doctor said as three more people standing nearby nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“No, I don’t want to cheat her of the experience,” Jordan said, scanning the nurses. “If anyone has a portable power source they’d let me borrow, let me know.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The doctor pulled one from his white coat, dropped it on the counter, and slid it over. “They let me know what’s going on. I called the admin for approval to bring that television up here. They’re clearing it with security and the loading dock.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Here, I have one,” a transport aide said, handing it to Jordan. A few others surrendered theirs as well.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Thank you,” Jordan said, scanning the faces of the medical team. “Thank you all so much.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ded8a92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter002.vue
// module id = 75
// module chunks = 0